import React, { useState, useCallback } from 'react';

import { Report } from '~/components';
import { Autocomplete, RadioGroup } from '~/components/Form';

export default function EstoqueOrgao() {
  const [open, setOpen] = useState(true);
  const [post, setPost] = useState({});

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const onSerializeData = useCallback((data) => ({
    ...data,
    postostr: post.poco_descricao,
    orgao: post.orga_codigo,
    orgaostr: post.orga_nome,
  }), [post]);

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      title="Estoque"
      relatorio="estoqueempresa"
      initials={{ tipo: 'pdf' }}
    >
      <Autocomplete
        name="posto"
        label="poco_desc_abrev"
        title="Posto"
        url="postosporusuario"
        unique="poco_codigo"
        getValue={(value) => setPost(value)}
      />

      <RadioGroup
        row
        name="tipo"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
      />
    </Report>
  )
}
